module.exports = __webpack_public_path__ + "static/media/logSattelite.9e350296.svg";